/**
 * @generated SignedSource<<bda7804edb079183311b9cc0c94e5783>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_RentalVehicle_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RentalVehicle",
        "kind": "LinkedField",
        "name": "rentalVehicle",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RentalVehicleContent_rentalVehicle"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routes_RentalVehicle_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RentalVehicle",
        "kind": "LinkedField",
        "name": "rentalVehicle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lon",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vehicleId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VehicleRentalUris",
            "kind": "LinkedField",
            "name": "rentalUris",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "android",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ios",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "web",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VehicleRentalNetwork",
            "kind": "LinkedField",
            "name": "rentalNetwork",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "networkId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a455854710e2c6048d9f209d9b98a500",
    "id": null,
    "metadata": {},
    "name": "routes_RentalVehicle_Query",
    "operationKind": "query",
    "text": "query routes_RentalVehicle_Query(\n  $id: String!\n) {\n  rentalVehicle(id: $id) {\n    ...RentalVehicleContent_rentalVehicle\n    id\n  }\n}\n\nfragment RentalVehicleContent_rentalVehicle on RentalVehicle {\n  lat\n  lon\n  name\n  vehicleId\n  rentalUris {\n    android\n    ios\n    web\n  }\n  rentalNetwork {\n    networkId\n    url\n  }\n}\n"
  }
};
})();

node.hash = "1f8d4ac2012c51636aad2df3e4d7e364";

export default node;
